export default {
  organizationLogo: '组织Logo',
  "configTitle": "用户认证配置",
  "personal": "个人认证",
  "enterprise": "组织认证",
  "personalDesc": "适用于个人用户实名认证，验证真实身份信息，提升账户可信度。",
  "enterpriseDesc": "适用于组织、社会团体、商会协会等机构，验证营业执照/登记证书及法人信息。",
  "enterpriseMaterials": "组织/商协会等机构必填材料",
  "materials": "申请材料",
  "verified": "已认证",
  "pending": "待审核",
  "unverified": "未认证",
  "materialsConfig": "申请材料配置",
  "rules": "⚙ 审核规则",
  "reviewMode": "审核方式",
  "manual": "人工审核",
  "deadline": "审核时限",
  "unset": "不设置",
  "validity": "认证有效期",
  "permanent": "长期有效",
  "notifications": "通过后自动发送通知",
  "sms": "短信通知（暂未开放）",
  "email": "邮件通知",
  "site": "站内消息（暂未开放）",
  "instruction": "认证说明（展示给申请人）",
  "save": "保存配置",
  "materialsHint": "请配置申请认证时需要提交的材料。",
  "reorderHint": "可拖拽调整顺序，点击 × 删除",
  "drag": "拖拽调整顺序",
  "materialName": "材料名称",
  "text": "单文本输入",
  "textarea": "多文本输入",
  "select": "下拉选择",
  "image": "图片",
  "required": "必填",
  "optional": "选填",
  "system": "系统项",
  "emptyMaterials": "暂无申请材料，请在下方添加。",
  "newMaterial": "添加新材料项",
  "add": "添加",
  "tip": "💡 提示：材料类型决定申请人在提交表单中看到的填写控件；删除材料不会清空已提交申请中的数据。",
  "cancel": "取消",
  "enterMaterial": "请输入材料名称",
  "saved": "认证配置已保存",
  "reviewTitle": "认证审核记录",
  "reviewed": "已审核",
  "pendingApplications": "待审核申请",
  "reviewHint": "点击「通过 / 驳回」即可完成审核",
  "approved": "已通过",
  "rejected": "已驳回",
  "status": "状态",
  "type": "类型",
  "startDate": "开始日期",
  "endDate": "结束日期",
  "search": "搜索申请编号 / 申请人",
  "applicationNo": "申请编号",
  "applicant": "申请人/机构",
  "verificationType": "认证类型",
  "submittedAt": "提交时间",
  "reviewer": "审核人",
  "reviewedAt": "审核时间",
  "result": "审核结果",
  "reasonPrefix": "驳回原因：",
  "actions": "操作",
  "viewMaterials": "查看材料",
  "details": "查看详情",
  "approve": "通过",
  "reject": "驳回",
  "reviewStatus": "审核状态",
  "submittedMaterials": "提交材料",
  "close": "关闭",
  "rejectTitle": "驳回认证申请",
  "rejectHint": "请填写驳回原因，申请人可根据原因重新提交。",
  "enterReason": "请输入驳回原因",
  "confirmReject": "确认驳回",
  "approveTitle": "通过认证",
  "confirmApprove": "确认通过",
  "approveSuccess": "认证申请已通过",
  "reviewFailed": "审核操作失败",
  "reasonRequired": "请填写驳回原因",
  "rejectSuccess": "认证申请已驳回",
  "verification": "认证状态",
  "standard": "普通会员",
  "realName": "已实名",
  "underReview": "审核中",
  "pendingDesc": "认证申请正在人工审核中，审核通过后将获得认证标识。",
  "rejectedDesc": "认证申请已被驳回，可补充资料后重新提交。",
  "unverifiedDesc": "该用户暂未完成实名认证。",
  "noPlan": "暂未获取套餐信息。",
  "planDefault": "可使用当前套餐配置的功能。",
  "days": "{n} 天",
  "materialsTitle": "{type} · 申请材料配置",
  "materialCount": "申请材料 {n} 项",
  "duplicate": "“{name}”已存在，请勿重复添加",
  "materialsSaved": "已保存 {type} 申请材料配置（{n}项）",
  "totalRecords": "共 {n} 条记录",
  "detailTitle": "认证材料查看 · {name}",
  "approvePrompt": "确认通过「{name}」的认证申请？通过后会同步更新用户和组织名称。",
  "approvedPersonal": "个人实名认证已通过，可正常使用对应套餐权益。",
  "approvedEnterprise": "组织实名认证已通过，可正常使用对应套餐权益。",
  "planBenefits": "{name}套餐权益：{text}",
  "companyCount": "{n} 家",
  "featureSeparator": "、",
  "organizationName": "组织/机构名称",
  "systemRealName": "真实姓名"
}
